import { render, staticRenderFns } from "./SysMenuWindow.vue?vue&type=template&id=4137583a&scoped=true&"
import script from "./SysMenuWindow.vue?vue&type=script&lang=js&"
export * from "./SysMenuWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137583a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4137583a')) {
      api.createRecord('4137583a', component.options)
    } else {
      api.reload('4137583a', component.options)
    }
    module.hot.accept("./SysMenuWindow.vue?vue&type=template&id=4137583a&scoped=true&", function () {
      api.rerender('4137583a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuWindow.vue"
export default component.exports